import { createSlice } from "@reduxjs/toolkit";

//Initial Value of Slice
const initialState = {
    List: [
        {
            Id : "Primary-1",
        }
    ]
}

//Action of Slice
const EmpFaqSlice = createSlice({
    name: "EmpFaq",
    initialState,
    reducers: {}
})

//Export of Slice
export const { } = EmpFaqSlice.actions;
export default EmpFaqSlice.reducer;